const en = {
    transactionTypes: {
        adjustment: 'Adjustment',
        authorization: 'Authorization',
        cashAdvance: 'Cash Advance',
        credit: 'Credit',
        default: 'Transaction',
        fee: 'Fee',
        interest: 'Interest',
        lateFee: 'Late Fee',
        payment: 'Payment',
        purchase: 'Purchase',
        refund: 'Refund'
    },
    common: {
        apiErrorHeading: 'Oops...',
        apiErrorMessage: 'Unfortunately we are unable to process your request at this time.\n Please try again later.',
        backButton: 'Back',
        closeButton: 'Close'
    },
    promotions: {
        accordionHeading: 'Promotional Term Details',
        accordionText: 'This table shows a summary of your promotional purchases. Including the types of promotions on your account. For more details, including promotion terms, refer to your statement.',
        activePromotionsHeading: 'Current Promotions',
        deferredInterestChargesCellValue: 'Deferred Interest\n Charges',
        deferredInterestChargesTableHeader: 'Deferred Interest\n Charges',
        descriptionTableHeader: 'Promotion Details/ Special Terms',
        detailsChartAmountPaidLabel: 'Amount paid',
        detailsChartHeading: 'Promotion Progress',
        detailsChartRemainingDaysLabel: 'Days remaining in 0% promo period',
        detailsDeferredInterestChargesLabel: 'Deferred Interest Charges',
        detailsExpirationDateLabel: 'Expiration Date',
        detailsPromotionalBalanceLabel: 'Promotional Balance',
        detailsPromotionDetailsHeading: 'Promotion Details',
        detailsPurchaseAmountLabel: 'Purchase Amount',
        detailsPurchaseDateLabel: 'Purchase Date',
        detailsSpecialTermsLabel: 'Special Terms',
        expirationDateCellValue: 'Expiration\n Date',
        expirationDateTableHeader: 'Expiration\n Date',
        expiredPromotionsHeading: 'Inactive Promotions',
        noPromotionsMessage: 'You have no promotions at this time',
        pastPromotionPeriodHeading: 'You are past your promotional period.',
        promotionalBalanceHeader: 'Promotional\n Balance',
        promotionalBalanceTooltip: 'Promotional Balance refers to the outstanding balance due on this promotion.',
        promotionPaidHeading: 'Congratulations!',
        promotionPaidSubHeading: 'Your balance has been paid off.',
        promotionsTableCaption: 'Promotions',
        purchaseAmountDateCellValue: 'Purchase\n Amount',
        purchaseDateCellValue: 'Purchase\n Date',
        purchaseDateTableHeader: 'Purchase\n Date',
        untilPaidOffCellValue: 'Until Paid Off'
    }
};
export default en;
//# sourceMappingURL=en.js.map